/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from "vue-svgicon";
icon.register({
  "icon-arrow": {
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    data:
      '<g transform="translate(-743.000000, -463.000000)" fill="#93A0BD" fill-rule="nonzero"><g transform="translate(396.000000, 136.000000)"><g transform="translate(229.488432, 313.000000)"><path d="M117.204183,16.5633846 L119.605233,18.9592036 C119.99558,19.3487003 120.627556,19.3487003 121.017903,18.9592036 L123.418953,16.5633846 C123.730881,16.2521366 124.23598,16.252412 124.547568,16.564 C124.859057,16.8754886 124.859057,17.3805114 124.547568,17.692 L121.018675,21.2208932 C120.628151,21.6114175 119.994986,21.6114175 119.604461,21.2208932 L116.075568,17.692 C115.76408,17.3805114 115.76408,16.8754886 116.075568,16.564 C116.387156,16.252412 116.892255,16.2521366 117.204183,16.5633846 Z" id="novaccess_icon_arrow_cta" transform="translate(120.311568, 18.964000) rotate(-90.000000) translate(-120.311568, -18.964000) "></path></g></g></g>',
  },
});
